import React from "react";
import styled from "styled-components";
import { formatTHB } from "../../../views/SubscriptionProjectV2/lib/formatters";

/**
 * Plan summary block — name on the left, price on the right.
 */
function PlanSummary({ plan, lang = "th" }) {
  if (!plan) {
    return (
      <EmptyState>
        {lang === "en" ? "No plan selected" : "ยังไม่ได้เลือกแพ็กเกจ"}
      </EmptyState>
    );
  }

  const isYearly = plan.installment_plan === "YEARLY";
  const periodLabel = isYearly
    ? lang === "en" ? "Yearly" : "รายปี"
    : lang === "en" ? "Monthly" : "รายเดือน";
  const suffix = isYearly
    ? lang === "en" ? "/ yr" : "/ ปี"
    : lang === "en" ? "/ mo" : "/ เดือน";

  return (
    <Wrapper>
      <SectionLabel>{lang === "en" ? "YOUR PLAN" : "แพ็กเกจของคุณ"}</SectionLabel>
      <Row>
        <Left>
          <PlanName>{plan.name_subscription_plan}</PlanName>
          <Period>{periodLabel}</Period>
        </Left>
        <Right>
          <Price>{formatTHB(plan.price)}</Price>
          <PriceSuffix>{suffix}</PriceSuffix>
        </Right>
      </Row>
    </Wrapper>
  );
}

export default React.memo(PlanSummary);

// ─── Styled ──────────────────────────────────

const Wrapper = styled.div`
  padding: 0 16px 12px;
`;

const SectionLabel = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: #9ca3af;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
`;

const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
`;

const Left = styled.div`
  min-width: 0;
`;

const PlanName = styled.div`
  font-weight: 600;
  font-size: 15px;
  color: #111827;
`;

const Period = styled.div`
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
`;

const Right = styled.div`
  text-align: right;
  flex-shrink: 0;
`;

const Price = styled.div`
  font-weight: 700;
  font-size: 18px;
  color: #111827;
  line-height: 1.1;
`;

const PriceSuffix = styled.div`
  font-size: 10px;
  color: #6b7280;
  margin-top: 2px;
`;

const EmptyState = styled.div`
  padding: 12px 16px;
  font-size: 12px;
  color: #9ca3af;
`;